module.exports = __webpack_public_path__ + "img/Cimarrones_hover.0275a842.png";